module.exports = __webpack_public_path__ + "static/media/paste.acc098b9.svg";